// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1PMoH","label":"CategoryService_label__2_846","location":"CategoryService_location__1BOZr"};